import "core-js/modules/es.string.repeat.js";
import "core-js/modules/es.string.fixed.js";
import { css } from 'styled-components';
function getBackgroundStyles(background) {
  return css(["background-image:", ";background-position:", ";background-size:", ";", ";"], background.image, background.position, background.size, !background.repeat && "\n\t\t\tbackground-repeat: no-repeat;\n\t\t");
}
export default function themedBackgroundStyles(_ref) {
  var theme = _ref.theme;
  var globals = theme.globals;
  if (!globals.background) {
    return null;
  }
  if (globals.background.fixed) {
    // If the background is fixed, we're adding it into a fixed pseudo element
    // covering the entire page background. This approach has much better
    // scrolling performance than using `background-attachment: fixed`
    return css(["body::before{content:'';position:fixed;width:100%;height:100%;top:0;left:0;z-index:", ";", " transform:translateZ(0);}"], globals.z.below, getBackgroundStyles(globals.background));
  } else {
    return css(["html{", "}"], getBackgroundStyles(globals.background));
  }
}